import store from '@/store'
import router from '@/router'
import {
  reactive,
  onBeforeMount,
  getCurrentInstance,
} from '@vue/composition-api'

import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'

import { setBannerModel } from '@/models/banner/banner'

export default function useCreateSetBanner(props) {
  const vm = getCurrentInstance().proxy
  const {
    fetchSetBannerModel,
    createSetBannerModel,
    editSetBannerModel,
  } = setBannerModel()
  const { openDefaultErrorModal, openSuccessModal } = useValidationModal()

  const loading = reactive({
    setBannerInfo: false,
    createEditSetBanner: false,
  })

  const setBannerData = reactive({
    setBannerId: null,
    setBanner: null,
    mappingBanner: null,
  })

  const bannerListTableConfig = reactive({
    isShow: true,
    displayKey: 'Banner_List',
    queryId: null,
    queryDataKey: 'Banner_List',
    isCreate: false,
  })

  const fetchSetBannerDetail = () => {
    window.$loading(true)
    loading.setBannerInfo = true

    const { setBannerId } = router.currentRoute.params
    setBannerData.setBannerId = setBannerId

    fetchSetBannerModel.payload.Set_Banner_Id = setBannerData.setBannerId
    store
      .dispatch('api/apiRequest', fetchSetBannerModel)
      .then(response => {
        setBannerData.setBanner = response.data.set_banner
        setBannerData.mappingBanner = response.data.mapping_banners
        loading.setBannerInfo = false
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const createSetBanner = (setBannerInfo, mappingBanner) => {
    window.$loading(true)
    createSetBannerModel.payload.Set_Name = setBannerInfo.name
    createSetBannerModel.payload.Description = setBannerInfo.description
    createSetBannerModel.payload.Valid_From = setBannerInfo.validFrom
    createSetBannerModel.payload.Valid_Through = setBannerInfo.validThrough
    createSetBannerModel.payload.Layout_Section = setBannerInfo.layoutSection
    createSetBannerModel.payload.Carousel = setBannerInfo.carousel
    createSetBannerModel.payload.Layout_Type = setBannerInfo.layoutType
    createSetBannerModel.payload.Status = setBannerInfo.status
    createSetBannerModel.payload.Banner_Mapping = mappingBanner
    loading.createEditSetBanner = true

    store
      .dispatch('api/apiRequest', createSetBannerModel)
      .then(response => {
        loading.createEditSetBanner = false

        const redirectFunction = () => {
          router.push('/banner/set/Banner_Set')
        }

        openSuccessModal(
          'ทำรายการสำเร็จ !',
          undefined,
          undefined,
          undefined,
          redirectFunction,
        )
      })
      .catch(err => {
        openDefaultErrorModal(err)
        loading.createEditSetBanner = false
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const editSetbanner = (setBannerInfo, mappingBanner) => {
    window.$loading(true)
    editSetBannerModel.payload.Set_Banner_Id = setBannerData.setBannerId
    editSetBannerModel.payload.Set_Name = setBannerInfo.name
    editSetBannerModel.payload.Description = setBannerInfo.description
    editSetBannerModel.payload.Valid_From = setBannerInfo.validFrom
    editSetBannerModel.payload.Valid_Through = setBannerInfo.validThrough
    editSetBannerModel.payload.Layout_Section = setBannerInfo.layoutSection
    editSetBannerModel.payload.Carousel = setBannerInfo.carousel
    editSetBannerModel.payload.Layout_Type = setBannerInfo.layoutType
    editSetBannerModel.payload.Status = setBannerInfo.status
    editSetBannerModel.payload.Banner_Mapping = mappingBanner
    loading.createEditSetBanner = true

    store
      .dispatch('api/apiRequest', editSetBannerModel)
      .then(response => {
        loading.createEditSetBanner = false

        openSuccessModal(
          'ทำรายการสำเร็จ !',
          undefined,
          undefined,
          undefined,
          resolveRedirect,
        )
      })
      .catch(err => {
        openDefaultErrorModal(err)
        loading.createEditSetBanner = false
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const onSubmitForm = () => {
    const setBannerInformationForm = vm.$refs.setbannerInfo
    const mappingBannerForm = vm.$refs.mappingBanner
    const mappingBanner = []

    const setBannerInfo = {
      name: setBannerInformationForm.form.name,
      description: setBannerInformationForm.form.description,
      layoutSection: setBannerInformationForm.form.layoutSection,
      carousel: setBannerInformationForm.form.carousel,
      layoutType: setBannerInformationForm.form.carouselLayout,
      status: setBannerInformationForm.form.status,
      validFrom: resolveDateObject(setBannerInformationForm.form.validFrom),
      validThrough: resolveDateObject(
        setBannerInformationForm.form.validThrough,
      ),
    }

    const mappingBannerTempt = mappingBannerForm.setMappingBannerTable.payload

    mappingBannerTempt.map((banner, index) => {
      mappingBanner.push({ Seq: index + 1, Banner_Id: banner.banner_id })
    })

    if (!props?.isEdit) {
      return createSetBanner(setBannerInfo, mappingBanner)
    }

    if (props?.isEdit) {
      return editSetbanner(setBannerInfo, mappingBanner)
    }
  }

  const resolveDateObject = dateObject => {
    const date = dateObject.date.split('-')
    const time = dateObject.time.split(':')

    const resolvedDate = `${date[2]}-${date[1]}-${date[0]} ${time[0]}:${time[1]}:00`

    return resolvedDate
  }

  const resolveRedirect = () => {
    const { params } = router.currentRoute

    if (params.bannerGroupId) {
      return router.push(
        `/banner/group/Banner_Group/${params.bannerGroupId}/info`,
      )
    }

    if (params.ref == 'Banner_Group') {
      return router.push('/banner/group/Banner_Group')
    }

    return router.push('/banner/set/Banner_Set')
  }

  onBeforeMount(() => {
    if (props?.isEdit) {
      fetchSetBannerDetail()
    }
  })

  return {
    bannerListTableConfig,
    setBannerData,
    loading,
    onSubmitForm,
    resolveRedirect,
  }
}
